import * as React from 'react';
import AccountsByFundGroupCore from '../FundGroupOrientation/AccountsByFundGroupCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import { UserRoleEnum } from '../../redux/UserSlice';

const AccountsByFiduciaryA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <AccountsByFundGroupCore userRole={isAdminUser ? "ADMIN" : "USER"}
                fundGroup="Fiduciary"
                noData="workState_noFiduciaryFunds"
                done="workState_fiduciaryFundsComplete"
                reviewed="reviewState_fiduciaryFundsReviewed"
            />
        </React.Fragment>
    );
}

export default AccountsByFiduciaryA;